import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import NuDate from "../../../../../Components/Utils/NuDate";

function PurchaseOrderSupplier() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/PO-shipment-status`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">PO Shipment Tracking</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200/50">
          In-Transit Feed
        </span>
      </div>

      {loading ? (
        <div className="h-56 flex items-center justify-center animate-pulse">
          <div className="h-36 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">PO Ref</th>
                <th className="py-2 px-2 text-left">Supplier</th>
                <th className="py-2 px-1 text-center">Mode</th>
                <th className="py-2 px-1 text-center">ETD</th>
                <th className="py-2 px-1 text-center">ETA</th>
                <th className="py-2 px-2 text-right">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-2.5 px-2 font-semibold text-gray-900">{item?.poRef || "N/A"}</td>
                    <td className="py-2.5 px-2 text-gray-700 truncate max-w-[120px]">{item?.supplier || "N/A"}</td>
                    <td className="py-2.5 px-1 text-center text-gray-500 font-medium">{item?.modeOfShipment || "N/A"}</td>
                    <td className="py-2.5 px-1 text-center text-gray-600">
                      {item?.ETD ? <NuDate value={item.ETD} format="DD MMM YYYY" /> : "N/A"}
                    </td>
                    <td className="py-2.5 px-1 text-center text-gray-600">
                      {item?.ETA ? <NuDate value={item.ETA} format="DD MMM YYYY" /> : "N/A"}
                    </td>
                    <td className="py-2.5 px-2 text-right">
                      <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200/50">
                        {item?.status || "N/A"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="py-6 text-center text-gray-400">
                    No shipment tracking data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default PurchaseOrderSupplier;
